module.exports = __webpack_public_path__ + "img/tron (63).7b19bf39.jpg";